export { default } from "~/components/footer/Footer";

export const eager = true;
export const sync = true;
export const layout = true;
